import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import routingService from 'common/src/modules/routing/routing.service';
import {CLRoute} from 'common/src/modules/routing/routing.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

const inputSchema = z.object({
  dashboardId: z.number().describe('The ID of the dashboard'),
  widgetId: z.number().describe('The ID of the widget'),
});

function highlightWidgetTool(store: CLStore) {
  async function execute({
    input: {dashboardId, widgetId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const state = store.getState();
    const {
      campaignPage: {
        campaignTree: {
          campaign: {id: campaignId},
          versionNumber,
        },
      },
    } = state;

    const queryParams = {
      ...Object.fromEntries(new URLSearchParams(document.location.search).entries()),
    };

    routingService.redirectTo({
      url: window.location.pathname as CLRoute,
      pathParams: {campaignId: campaignId, versionNumber},
      queryParams: {
        ...queryParams,
        mode: 'dashboard',
        dashboardId,
        widgetId,
        steps: CampaignStep.Insights,
      },
    });

    return toolResult('Success');
  }

  return tool({
    name: CampaignAnalyticsToolName.HighlightWidget,
    displayName: 'Preparing widget',
    description: 'highlight a dashboard widget',
    execute,
    inputSchema,
  });
}

export default highlightWidgetTool;
